export const DRAG_CELL_START = 'DRAG_CELL_START'
export const DRAG_CELL_END = 'DRAG_CELL_END'
export const DRAG_CELL_REORDER = 'DRAG_CELL_REORDER'
export const DRAG_CELL_INITIALIZE = 'DRAG_CELL_INITIALIZE'



// WEBPACK FOOTER //
// ./src/components/drag-cell/constants.ts